/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoice_CapInputs */

const cs_billing_invoice_cap = /** @type {(inputs: Billing_Invoice_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit kreditů na faktuře`)
};

const en_billing_invoice_cap = /** @type {(inputs: Billing_Invoice_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice credit cap`)
};

/**
* | output |
* | --- |
* | "Invoice credit cap" |
*
* @param {Billing_Invoice_CapInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoice_cap = /** @type {((inputs?: Billing_Invoice_CapInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoice_CapInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_invoice_cap(inputs)
	return cs_billing_invoice_cap(inputs)
});